import { Component } from '@angular/core';

@Component({
  selector: 'app-footer',
  imports: [],
  templateUrl: './footer.html',
  styleUrl: './footer.scss'
})
export class Footer {
  // The timestamp is static as per the request.
  // For a dynamic date, you would use:
  lastUpdated = new Date().toUTCString();
  footerText = "Last updated at 2025-08-03 01:03:28 UTC. " +
    "As an Amazon Associate I earn from qualifying purchases. " +
    "Product prices and availability are accurate as of the date/time " +
    "indicated and are subject to change. " +
    "Any price and availability information displayed at the time " +
    "of purchase will apply to the purchase of the product. " +
    "CERTAIN CONTENT THAT APPEARS ON THIS SITE COMES FROM " +
    "AMAZON SERVICES LLC. THIS CONTENT IS PROVIDED 'AS IS' AND " +
    "IS SUBJECT TO CHANGE OR REMOVAL AT ANY TIME. " +
    "All other content is Copyright Bright Start Creations. " +
    "All rights reserved."
}
